<template>
  <b-card title="ผลการค้นหา">
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      :line-numbers="true"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }"
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: false, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
      @on-page-change="onPageChange"
      @on-per-page-change="onPageLengthChange"
      :totalRows="totalRecords"
    >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'complaintCode'" class="text-nowrap">
          <span class="text-nowrap">{{ props.row.complaintCode }}</span>
        </span>

        <span v-if="props.column.field === 'qllName'" class="text-nowrap">
          <span class="text-nowrap">{{ props.row.qlName }}</span>
        </span>

        <span v-if="props.column.field === 'qllStatus'" class="text-nowrap">
          <span class="text-nowrap">{{ props.row.qllStatus }}</span>
        </span>

        <span v-if="props.column.field === 'qllRemark'" class="text-nowrap">
          <span class="text-nowrap">{{ props.row.qllRemark }}</span>
        </span>

        <span v-else-if="props.column.field === 'action'">
          <!-- ปุ่มจัดการแสดงเฉพาะ เรื่องที่ยังไม่ Done -->
          <span v-if="props.row.isQueueLoaderLineResendAble === true">
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-primary"
                  class="text-body align-middle mr-25"
                >
                  <feather-icon icon="SettingsIcon" class="mr-50" />
                  <span class="align-middle">จัดการ</span>
                </b-button>
              </template>
              <b-dropdown-item @click="onRepeatBtnClicked()">
                <feather-icon icon="Edit2Icon" class="mr-50" />
                <span>ส่งซ้ำ</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>
        <!-- v-if="props.rows.qllStatus !== 'Done' -->
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              แสดง 1 ถึง
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['10', '25', '50', '100']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> จาก {{ props.total }} รายการ </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </b-card>
</template>

<script>
import {
  BButton,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BCard,
  BCardHeader,
  BCardBody,
  BTab,
  BTabs,
  BOverlay,
} from "bootstrap-vue";

import { VueGoodTable } from "vue-good-table";
import Ripple from "vue-ripple-directive";
import store from "@/store/index";
import { codeBasic } from "@/views/table/vue-good-table/code";
import * as userData from "@/auth/localStorageUtils.js";
import TableHeaders from "@/views/Complaint/components/ComplaintGroup/components/commonTableHeader.js";
import * as complaintGroupStore from "@/store/api/complaint/complaintGroup.js";

export default {
  directives: {
    Ripple,
  },
  components: {
    VueGoodTable,
    BButton,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BCard,
    BCardHeader,
    BCardBody,

    TableHeaders,
    BTab,
    BTabs,
    BOverlay,
    BCard,
  },
  props: {
    qlId: "",
  },
  setup(props) {
    return {};
  },
  data() {
    return {
      pageLength: 10,
      dir: false,
      codeBasic,
      columns: TableHeaders,
      rows: [],
      searchTerm: "",
      params: {},
      totalRecords: 0,
      status: [
        {
          1: "Current",
          2: "Professional",
          3: "Rejected",
          4: "Resigned",
          5: "Applied",
        },
        {
          1: "light-primary",
          2: "light-success",
          3: "light-danger",
          4: "light-warning",
          5: "light-info",
        },
      ],
      qllIdsList: [],
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: "light-primary",
        Professional: "light-success",
        Rejected: "light-danger",
        Resigned: "light-warning",
        Applied: "light-info",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  created() {},
  methods: {
    onPageChange(page) {
      console.log("onPageChanged", page);
      this.onSearchSubmit(this.params, page);
    },
    onPageLengthChange(pageLength) {
      console.log("onPageLengthChanged", pageLength);
      this.onSearchSubmit(this.params, 1);
    },
    onSearchSubmit(params, page = { currentPage: 1 }) {
      console.log("getQueueLoaderLineByQueueLoderId", params);

      const _this = this;
      if (_this.qlId) params.qlId = _this.qlId;
      params.page = page.currentPage;
      params.perPage = _this.pageLength;

      complaintGroupStore
        .getQueueLoaderLineByQueueLoderId(params)
        .then(function(response) {
          console.log("getQueueLoaderLineByQueueLoderId", response);
          _this.totalRecords = response.data.data[0].totalCount;
          _this.rows = response.data.data;

          console.log("_this.rows", _this.rows);

          // เอาเฉพาะ qllId
          _this.qllIdsList = response.data.data.map((value) => {
            return value.qllId;
          });

          console.log("_this.qllIdsList", _this.qllIdsList);
        })
        .catch(function(error) {
          console.log("error", error);
        })
        .then(function() {
          _this.$emit("handleOverlay", false);
        });
    },
    onRepeatBtnClicked() {
      const _this = this;

      console.log("onRepeatBtnClicked");
      console.log("onRepeatBtnClicked", _this.qllIdsList);

      this.$swal({
        title: "คุณต้องการส่งเอกสารอีกครั้งใช่หรือไม่?",
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ส่งเอกสารอีกครั้ง",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          complaintGroupStore
            .queueLoaderLineResend(_this.qllIdsList)
            .then(function(response) {
              console.log("onRepeatBtnClicked", response);
              if (response.data.success === true) {
                this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                  title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                  variant: "success",
                  solid: false,
                });
              } else {
                _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                  title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                  variant: "danger",
                  solid: false,
                });
              }
            })
            .catch(function(error) {
              console.log("error", error);
            })
            .then(function() {
              _this.$emit("handleOverlay", false);
            });
        }
      });
    },
    onDeleteBtnClicked(id) {
      const _this = this;
      this.$swal({
        title: "คุณต้องการลบข้อมูลใช่หรือไม่?",
        text: "เมื่อลบแล้วไม่สามารถกู้คืนได้อีก!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ลบข้อมูล",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          roleStore
            .deleteItem(id)
            .then((response) => {
              if (response.data.success === true) {
                this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                  title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                  variant: "success",
                  solid: false,
                });

                this.onSearchSubmit({});
              } else {
                _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                  title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                  variant: "danger",
                  solid: false,
                });
              }
            })
            .catch((error) => {
              console.log("error", error);
              _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                variant: "danger",
                solid: false,
              });
            });
        }
      });
    },
    // confirmText() {
    //   this.$swal({
    //     title: "คุณต้องการลบข้อมูลใช่หรือไม่?",
    //     text: "เมื่อลบแล้วไม่สามารถกู้คืนได้อีก!",
    //     icon: "warning",
    //     showCancelButton: true,
    //     confirmButtonText: "ลบข้อมูล",
    //     customClass: {
    //       confirmButton: "btn btn-primary",
    //       cancelButton: "btn btn-outline-danger ml-1",
    //     },
    //     buttonsStyling: false,
    //   }).then((result) => {
    //     if (result.value) {
    //       this.$swal({
    //         icon: "success",
    //         title: "ลบข้อมูล สำเร็จ",
    //         customClass: {
    //           confirmButton: "btn btn-success",
    //         },
    //       });
    //     }
    //   });
    // },
  },
};
</script>
